import { useQuery } from "react-query";
import { Get } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";

export interface PackageTemplate {
  id: string;
  name: string;
  length: number;
  width: number;
  height: number;
  organization_id: string;
  dimension_unit: string;
}

export default (org_id: string) => {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery<PackageTemplate[], Error>(
    [`package_templates_${org_id}`],
    async () => {
      const token = await getAccessTokenSilently();
      return Get<PackageTemplate[]>(
        `/api/package_template/organization/${org_id}`,
        token
      );
    }
  );
};
